import { render, staticRenderFns } from "./DetailsContactInfoFrund.vue?vue&type=template&id=50604348&"
import script from "./DetailsContactInfoFrund.vue?vue&type=script&lang=js&"
export * from "./DetailsContactInfoFrund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports